<template>
    <div class="confirm-wraper">
        <div class="top">
            <div class="top-img"/>
            <div class="right"></div>
            <div class="content">
                <div class="title">百度法行宝 {{ formData.business_name ? '& ' + formData.business_name : '' }}</div>
                <div class="sub-title">尊敬的{{ formData.lawyer_name ? formData.lawyer_name : '' }}律师，欢迎您入驻法行宝</div>
                <div class="tip">请确认您的律师信息，一键入驻法行宝并关联账号，即可获得百度专属律师名片</div>
            </div>
        </div>
        <div class="container">
            <div class="left">
                <div class="title">
                    律师信息确认与编辑
                </div>
                <div class="careers">
                    <veui-form
                        ref="form"
                        :validators="validators"
                        :data="formData"
                        class="form isViewModel"
                    >
                        <veui-field
                            name="personal_avatar"
                            field="personal_avatar"
                            label="真实头像"
                            :rules="[{name: 'required', value: true, message: '请上传真实头像'}]"
                        >
                            <cropper-avator
                                item="case_pic"
                                field="case_pic"
                                :is-cropped="true"
                                :max-size="5120"
                                :url="`${url}&bucketName=law_smart&storeDir=honorary_licence&ajax=true`"
                                :is-not-essential="true"
                                :img-src="!formData.personal_avatar ? '' : formData.personal_avatar"
                                @upload-suc="uploadSuc"
                            ></cropper-avator>
                        </veui-field>
                        <veui-field
                            name="lawyer_name"
                            field="lawyer_name"
                            label="律师姓名"
                            :rules="[{name: 'required', value: true, message: '请输入姓名'}]"
                        >
                            <veui-input
                                v-model="formData.lawyer_name"
                                clearable
                                placeholder="请输入您的真实姓名，如：杨在明"
                                autocomplete="off"
                            />
                        </veui-field>
                        <veui-field
                            name="register_id"
                            field="register_id"
                            label="执业证号"
                            :rules="[{name: 'required', value: true, message: '请输入执业证号'}]"
                        >
                            <veui-input
                                v-model="formData.register_id"
                                clearable
                                placeholder="请输入您的执业证号"
                                autocomplete="off"
                                :maxlength="17"
                            />
                        </veui-field>
                        <veui-field
                            name="lawyer_phone"
                            field="lawyer_phone"
                            label="执业手机"
                            class="register-id-field"
                            :rules="[{name: 'required', value: true, message: '请输入执业手机'}]"
                        >
                            <veui-input
                                v-model="formData.lawyer_phone"
                                clearable
                                placeholder="请输入您的执业手机号，将用于咨询连线，请确保正确且可公开"
                                autocomplete="off"
                                :maxlength="11"
                            />
                        </veui-field>
                        <veui-field
                            name="register_years"
                            field="register_years"
                            label="执业年限"
                            class="register-id-field"
                            :rules="[{name: 'required', value: true, message: '请输入执业年限'}]"
                        >
                            <veui-input
                                v-model="formData.register_years"
                                clearable
                                placeholder="请输入您的执业年限，请确保和与执业证号一致"
                                autocomplete="off"
                                oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=null"
                            />
                        </veui-field>
                        <veui-field
                            label="从业地区"
                            field="register_region"
                            name="register_region"
                            :rules="[{name: 'required', value: true, message: '请选择从业地区'}]"
                        >
                            <Cascader
                                v-model="formData.register_region"
                                :data="regionOption"
                                placeholder="请选择您的从业地区"
                                clearable
                            >
                            </Cascader>
                            <div class="decs">
                                <span
                                    class="form-href-terms form-city"
                                    pointer
                                    @click.stop="goto('city')"
                                >《城市等级列表》</span>
                            </div>
                        </veui-field>
                        <veui-field
                            label="律师职务"
                            field="lawyer_position"
                            name="lawyer_position"
                            :rules="[{name: 'required', value: true, message: '请选择律师职务'}]"
                        >
                            <veui-check-button-group
                                v-model="formData.lawyer_position"
                                :check="false"
                                ui="simple"
                                :items="positionList"
                            />
                        </veui-field>
                        <veui-field
                            id="register_domain"
                            label="擅长领域"
                            data-stat-ignore
                            name="register_domain"
                            field="register_domain"
                            :rules="[{name: 'required', value: true, message: '请选择擅长领域'}]"
                        >
                            <veui-select
                                v-model="formData.register_domain"
                                :placeholder="'请选择您的擅长领域，最多选择' + lawyerFieldsNum + '个领域标识'"
                                data-stat-ignore
                                :overlay-class="showSelectedSecond
                                    ? 'register-domain-picker show-selected-second' : 'register-domain-picker'"
                                clearable
                                multiple
                                @toggle="selectToggle"
                            >
                                <veui-option-group
                                    v-for="(item, index) in doaminOption"
                                    :key="index"
                                    :label="item.name"
                                    position="popup"
                                >
                                    <veui-option
                                        v-for="item in item.children"
                                        :key="item.id"
                                        overlay-class="register-domain-second"
                                        :value="item.name"
                                        :label="item.name"
                                    />
                                </veui-option-group>
                            </veui-select>
                        </veui-field>
                        <veui-field
                            class="veui-field-personal_intro honorary"
                            name="personal_intro"
                            field="personal_intro"
                            ui="m"
                            label="个人简介"
                            :rules="[{name: 'required', value: true, message: '请输入律师简介'}]"
                        >
                            <div class="textarea-box">
                                <veui-textarea
                                    v-model="formData.personal_intro"
                                    class="textarea"
                                    placeholder="请输入个人简介，20-500字符，不得出现联系方式、具体涉案金额。
范例：X律师执业以来，参与处理了许多的民商事案件、刑事辩护案件，积
累了丰富的办案经验，为当事人争取最大的合法权益。"
                                    :resizable="false"
                                />
                                <div class="text-number">
                                    <span
                                        :class="[
                                            'text-number-normal',
                                            formData.personal_intro.length >= 0 ? 'text-number-blue' : '',
                                            formData.personal_intro.length > 500 ? 'text-number-red' : '',
                                        ]"
                                    >{{ formData.personal_intro.length }}</span>/500
                                </div>
                            </div>
                        </veui-field>
                        <veui-field
                            name="user_info"
                            field="user_info"
                            label="百度账号"
                            :rules="[{name: 'required', value: true}]"
                        >
                            <veui-input
                                v-model="formData.user_info"
                                class="user-info"
                                readonly
                                clearable
                            />
                        </veui-field>
                        <veui-field
                            class="form-agree"
                            :class="showAgreeTip ? 'agree-tip' : ''"
                            name="isAgree"
                            field="isAgree"
                            label=""
                        >
                            <veui-checkbox v-model="formData.isAgree" :false-value="null">我已阅读并知晓 </veui-checkbox>
                            <span class="form-href-terms" @click.stop="goto('serve')">《律师入驻服务条款》</span>
                            <span class="form-href-terms" @click.stop="goto('agree')">《信息真实承诺书》</span>
                        </veui-field>
                    </veui-form>
                    <div class="submit-field">
                        <veui-button
                            class="ml5 submit-field-btn" @click="postData('normal')"
                        >保存</veui-button>
                        <veui-button
                            class="submit-field-btn submit-field-btn-confirm" ui="primary"
                            @click="postData('submit')"
                        >
                            提交审核
                        </veui-button>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="title">审核要求</div>
                <div class="topic">真实头像审核要求</div>
                <div class="paragraph">1. 请参考示意图上传本人近期正面、免冠头像</div>
                <div class="paragraph">2. 照片要求透明底，即抠图人像，以保证审核通过，权益展现</div>
                <div class="paragraph">3. 图片要求png格式，1M以内</div>
                <div class="case">
                    <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/right.png" alt="" />符合标准的照片范例
                </div>
                <div class="right-img">
                    <div class="right-img-item">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/nan.png" alt="" />
                    </div>
                    <div class="right-img-item">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/nv.png" alt="" />
                    </div>
                </div>
                <div class="case">
                    <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/error.png" alt="" />不符合标准的情况
                </div>
                <div class="error-img">
                    <div class="error-img-item">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/error1.png" alt="" />
                    </div>
                    <div class="error-img-item">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/error2.png" alt="" />
                    </div>
                    <div class="error-img-item">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/error3.png" alt="" />
                    </div>
                    <div class="error-img-item">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/error4.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isLoading" class="loading-box">
            <main-loading/>
        </div>
        <div v-if="showAlreadyUser" class="already-user">
            <div class="already-user-content">
                <div class="title">您已有法行宝账号，请重新登录</div>
                <div class="sub-title">当前登录账号非法行宝绑定账号，请重新登录</div>
                <!-- <div class="close" @click="() => showAlreadyUser = false"><veui-icon
                    :style="{width: '20px', height: '20px', color: '#000'}" class="circle-icon"
                    name="times"
                /></div> -->
                <div class="lawyer">
                    <div class="lawyer-box">
                        <div class="avator">
                            <img :src="alreadyLawyerAvatar">
                        </div>
                        <div class="lawyer-info">{{ alreadyLawyerName }}律师({{ alreadyLawyerPhone }})</div>
                    </div>
                    <div class="info">法行宝账号</div>
                </div>
                <div class="btns" @click="logout">重新登录</div>
                <div class="sub-bot-title">若该法行宝账号不可用，请联系客服lvlin_help@baidu.com解绑</div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @author baoleilei
 * @desc 我的资料-个人认证
 */
/* global passport */
// import {Steps, Loading} from 'veui';
import {isBoolean} from 'lodash';
import {
    Button,
    Form,
    Field,
    Input,
    Select,
    Textarea,
    Checkbox,
    OptionGroup,
    Option,
    CheckButtonGroup
} from 'veui';
import 'veui-theme-dls-icons/check-circle';
import mixinajax from '@/mixins/ajax';
import cropperAvator from '../../material/views/cropper-avator.vue';
import MainLoading from '../../../components/law/main-loading.vue';
import {passportOrigin} from '../../../../config/constant';
import {withBase} from '@/utils/basePath';

const url = {
    domain: '/bp/api/lawyer/get_lawyer_domain',
    cityNext: '/bp/api/city/cityAll',
    confirmIndex: '/bp/api/business_lawyer/index',
    save: '/bp/api/business_lawyer/save'
};

export default {
    name: 'matrial',
    mixins: [mixinajax],
    components: {
        'veui-button': Button,
        'veui-field': Field,
        'veui-form': Form,
        'veui-input': Input,
        'veui-select': Select,
        'veui-textarea': Textarea,
        'veui-checkbox': Checkbox,
        'veui-option-group': OptionGroup,
        'veui-option': Option,
        'cropper-avator': cropperAvator,
        'veui-check-button-group': CheckButtonGroup,
        MainLoading
    },
    data() {
        let self = this;
        return {
            url: '/bp/api/upload?ajax=1&bdstoken=',
            regionOption: [], // 省市区
            doaminOption: [], // 擅长领域
            lawyerFieldsNum: 2,
            positionList: [
                {
                    label: '专职律师',
                    value: '专职律师',
                    exclusive: true
                },
                {
                    label: '主任律师',
                    value: '主任律师',
                    exclusive: true
                },
                {
                    label: '合伙人律师',
                    value: '合伙人律师',
                    exclusive: true
                },
                {
                    label: '高级合伙人律师',
                    value: '高级合伙人律师',
                    exclusive: true
                }
            ],
            validators: [
                {
                    fields: ['personal_intro'],
                    validate(personal_intro) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                if (personal_intro && (personal_intro.length < 20 || personal_intro.length > 500)) {
                                    res = {
                                        personal_intro: '请输入20-500个字符'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                },
                {
                    fields: ['register_years', 'lawyer_position'],
                    validate(register_years, lawyer_position) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                if (register_years && +register_years < 0) {
                                    res = {
                                        register_years: '不能为负数'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                },
                {
                    fields: ['register_domain'],
                    validate(register_domain) {
                        // let that = this;
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                let lawyerFieldsNum = self.formData.max_fields_num || 2;
                                if (register_domain && (register_domain.length > lawyerFieldsNum)) {
                                    res = {
                                        register_domain: `您最多只能筛选${lawyerFieldsNum}个领域标签`
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                },
                {
                    fields: ['lawyer_phone'],
                    validate(lawyer_phone) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                lawyer_phone = lawyer_phone + '';
                                let isPhone = (/^1[3456789]\d{9}$/.test(lawyer_phone))
                                    || (/^[1][3-9]{2}(\*\*\*\*)[0-9]{4}$/.test(lawyer_phone));
                                if (!isPhone) {
                                    res = {
                                        lawyer_phone: '请输入正确的手机号'
                                    };
                                }
                                if (!lawyer_phone) {
                                    res = null;
                                }
                                return resolve(res);
                            });
                        });
                    }
                },
                {
                    fields: ['register_id'],
                    validate(register_id) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                register_id = register_id + '';
                                if (+register_id < 0) {
                                    res = {
                                        register_id: '不能为负数'
                                    };
                                }
                                else if (register_id && register_id.length !== 17) {
                                    res = {
                                        register_id: '请输入17位执业证书号'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                }
            ],
            formData: {
                isAgree: null,
                max_fields_num: 2,
                personal_avatar: '',
                lawyer_name: '',
                register_id: '',
                lawyer_phone: '',
                register_years: '',
                register_region: [],
                lawyer_position: [],
                register_domain: [],
                personal_intro: '',
                register_law_firm: '',
                user_info: '',
                business_code: '',
                business_lawyer_id: ''
            },
            isLoading: true,
            lawyerUk: '',
            showAlreadyUser: false,
            alreadyLawyerName: '',
            alreadyLawyerPhone: '',
            alreadyLawyerAvatar: '',
            alreadyLawyerFirm: '',
            authToken: '',
            uk: '',
            vipStatusName: '',
            showAgreeTip: false,
            showSelectedSecond: false
        };
    },
    created() {
        const {authToken} = this.$route.query;
        this.authToken = authToken;
        this.init(authToken);
    },
    mounted() {
        document.body.classList.add('lawyer-confirm');
        window.addEventListener('beforeunload', this.beforUnloadFn);
        const register = document.querySelector('.register-domain-picker');
        register && register.addEventListener('click', e => {
            if (e.target.className === 'veui-option-group'
                || e.target.className.indexOf('veui-option-group-label') >= 0
                || e.target.className === 'veui-option-label') {
                this.showSelectedSecond = true;
            }
        });
        const trigger = document.querySelector('.veui-select-trigger');
        trigger && trigger.addEventListener('click', e => {
            if (e.target.className === 'veui-tag-label') {
                this.showSelectedSecond = false;
            }
        });
    },
    destroyed() {
        document.body.classList.remove('lawyer-confirm');
        window.removeEventListener('beforeunload', this.beforUnloadFn);
    },
    computed: {
    },
    watch: {
    },
    methods: {
        selectToggle(e) {
            if (!e) {
                this.showSelectedSecond = false;
            }
        },
        beforUnloadFn(e) {
            const confirmationMessage = '您还未保存填写内容，确定离开？';
            (e || window.event).returnValue = confirmationMessage; // 兼容 Gecko + IE
            return confirmationMessage; // 兼容 Gecko + Webkit, Safari, Chrome
        },
        goto(type) {
            if (type === 'serve') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/lawyer_rule.pdf');
            }
            else if (type === 'city') {
                window.open('https://lvlin-base.cdn.bcebos.com/fe-saas/common/city_level.pdf');
            }
            else if (type === 'phone') {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/phone_apply_rule.pdf');
            }
            else {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/160705507337529aaa5c.pdf');
            }
        },
        logout() {
            this.$wywLog.send({
                serverId: 17245,
                action: 'click',
                page: 'lawyer-confirm',
                area: 'login-cxdltc-btn'
            });
            let href = location.protocol + '//'
                + location.host
                + withBase('/login') + '?authToken='
                + this.$route.query.authToken
                + '&name=' + this.alreadyLawyerName
                + '&firm=' + this.alreadyLawyerFirm;
            let passUrl = `${passportOrigin}/?logout`;
            window.location = passUrl + '&tpl=lvlin&u=' + encodeURI(href);
        },
        submitInfo(params = {}) {
            if (this.isLoading) {
                return;
            }
            if (!this.formData.isAgree) {
                this.showAgreeTip = true;
                if (this.agreeTimeout) {
                    clearTimeout(this.agreeTimeout);
                    this.agreeTimeout = null;
                }
                this.agreeTimeout = setTimeout(() => {
                    this.showAgreeTip = false;
                    clearTimeout(this.agreeTimeout);
                    this.agreeTimeout = null;
                }, 1500);
                return;
            }
            this.isLoading = true;
            this.$wywLog.send({
                serverId: 17245,
                action: 'click',
                page: 'lawyer-confirm',
                area: 'lawyer-confirm-tjsh-btn',
                uk: this.uk,
                vipStatusName: this.vipStatusName
            });
            this.$http.post(url.save, {
                ...params,
                name: params.lawyer_name,
                register_id: params.register_id,
                register_years: +params.register_years,
                personal_avatar: params.personal_avatar,
                personal_intro: params.personal_intro,
                mobile_number: params.lawyer_phone,
                register_region: params.register_region.join('$'),
                register_domain: params.register_domain.join('$'),
                lawyer_position: params.lawyer_position.join(''),
                authToken: this.authToken
            }).then(res => {
                if (res && res.code && res.code === '0') {
                    this.$Message.success('提交成功!');
                    window.removeEventListener('beforeunload', this.beforUnloadFn);
                    setTimeout(() => {
                        this.gotoLawyerInfo(1);
                    }, 2000);
                }
                else {
                    this.$toast.error(res && res.msg || '提交失败，请稍候再试~');
                }
                this.isLoading = false;
            }).catch(error => {
                this.$toast.error(error && error.msg || '提交失败，请稍候再试~');
                this.isLoading = false;
            });
        },
        init(authToken) {
            this.$http.get(url.confirmIndex, {
                params: {
                    authToken
                }
            }).then(res => {
                if (res && +res.code === 10010) {
                    window.removeEventListener('beforeunload', this.beforUnloadFn);
                    this.$router.push({
                        name: 'login',
                        query: {
                            authToken,
                            name: res.data && res.data.exit_lawyer && res.data.exit_lawyer.name || '',
                            firm: res.data && res.data.exit_lawyer && res.data.exit_lawyer.register_law_firm || ''
                        }
                    });
                    return;
                }
                this.uk = res.data && res.data.uk || '';
                this.vipStatusName = res.data && res.data.vip_code_type_txt || 0;
                this.$wywLog.send({
                    serverId: 17245,
                    action: 'show',
                    page: 'lawyer-confirm',
                    area: 'lawyer-confirm-pv',
                    uk: this.uk,
                    vipStatusName: this.vipStatusName
                });
                if (res.data && res.data.exit_lawyer) {
                    this.alreadyLawyerName = res.data.exit_lawyer.name;
                    this.alreadyLawyerPhone = res.data.exit_lawyer.bd_account || res.data.exit_lawyer.mobile_number; // 之前展示手机号，后面修改成百度账号昵称了
                    this.alreadyLawyerAvatar = res.data.exit_lawyer.personal_avatar;
                    this.alreadyLawyerFirm = res.data.exit_lawyer.register_law_firm;
                    this.showAlreadyUser = true;
                    this.$wywLog.send({
                        serverId: 17245,
                        action: 'show',
                        page: 'lawyer-confirm',
                        area: 'login-cxdltc'
                    });
                    return;
                }
                if (res.data && +res.data.is_bind === 0) {
                    const data = res.data;
                    const region = data.register_region.split('$')?.map(i => +(i)) || [];
                    const uk = data.uk;
                    this.lawyerUk = uk;
                    this.getDomain(data.register_domain);
                    this.getCity();
                    const localData = localStorage.getItem(`${uk}_${data.business_code}_${data.business_lawyer_id}`);
                    if (uk && localData) {
                        this.formData = JSON.parse(localData || '{}');
                        return;
                    }
                    this.formData = {
                        ...data,
                        isAgree: null,
                        max_fields_num: 2,
                        personal_avatar: data.personal_avatar,
                        lawyer_name: data.name,
                        register_id: data.register_id,
                        lawyer_phone: data.mobile_number,
                        register_years: data.register_years,
                        register_region: region,
                        lawyer_position: [data.lawyer_position],
                        personal_intro: data.personal_intro,
                        register_law_firm: data.register_law_firm,
                        user_info: data.bd_account + (data.bd_mobile ? '(' + data.bd_mobile + ')' : ''),
                        business_code: data.business_code,
                        business_lawyer_id: data.business_lawyer_id
                    };
                }
                else {
                    this.gotoLawyerInfo();
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        postData(op_type) {
            if (op_type === 'submit') {
                this.$refs.form.validate().then(flag => {
                    if (isBoolean(flag) && flag) {
                        this.save();
                    }
                    else {
                        let toast = {
                            content: '请完成必填选项',
                            duration: 1
                        };
                        this.$Message.info(toast);
                    }
                });
            }
            else {
                if (this.lawyerUk) {
                    localStorage.setItem(
                        `${this.lawyerUk}_${this.formData.business_code}_${this.formData.business_lawyer_id}`,
                        JSON.stringify(this.formData));
                    this.$Message.success('保存成功!');
                }
            }
        },
        gotoLawyerInfo(isShowModal) {
            let href = location.protocol + '//'
                + location.host + withBase('/lawinfo')
                + (isShowModal
                    ? (
                        '?formFirmAuth=1&name='
                        + this.formData.lawyer_name
                        + '&uk=' + this.uk + '&vipStatusName='
                        + this.vipStatusName
                    )
                    : ''
                );
            window.location.href = href;
        },
        save() {
            this.submitInfo({
                ...this.formData
            });
        },
        uploadSuc(item, url) {
            this.formData.personal_avatar = url || '';
        },
        getCity(city_code = 0) {
            this.$http.get(url.cityNext, {
                city_code
            }).then(res => {
                if (!res || +res.code !== 0) {
                    return;
                }
                let data = res.data;
                if (data) {
                    this.regionOption = data;
                }
            });
        },
        getDomain(domain) {
            this.$http.get(url.domain, {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (res) {
                    let data =  res;
                    let hasDomain = [];
                    data && data.forEach(element => {
                        if (element.children) {
                            element.children.forEach(item => {
                                if (domain.indexOf(item.name) >= 0) {
                                    hasDomain.push(item.name);
                                }
                            });
                        }
                    });
                    this.formData = {
                        ...this.formData,
                        register_domain: hasDomain
                    };
                    this.doaminOption = data;
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
    @color0: #ffffff;
    @color1: #000000;
    @color2: #848b99;

    @width1: 570px;
    @width5: 100%;

    @height2: 100%;
    @height4: 48px;
    .confirm-wraper {
        width: 100%;
        min-width: 1280px;
        background: #fcfdfe;
        background-image: linear-gradient(to bottom, #F5F8FB, #FCFDFE);
        padding-bottom: 130px;
        .top {
            width: 100%;
            height: 270px;
            position: relative;
            margin-bottom: 20px;
            .top-img {
                width: 100%;
                height: 270px;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                z-index: 2;
                background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/top-new-2.png') no-repeat;
                background-size: 1674px 270px;
                background-position: center top;
            }
            .right {
                width: 100%;
                height: 270px;
                transform: scaleX(-1);
                background-image: linear-gradient(270deg, #CDEDFC 0%, #CBEAFC 100%);
                position: absolute;
                right: 0;
                top: 0;
                z-index: 1;
            }
            .content {
                width: 1280px;
                height: 270px;
                position: absolute;
                top: 0;
                left: 50%;
                z-index: 3;
                transform: translateX(-640px);
                padding: 60px 0 0 30px;
                box-sizing: border-box;
                .title {
                    font-family: PingFangSC-Medium;
                    font-size: 40px;
                    color: #1E1F24;;
                    letter-spacing: 1px;
                    line-height: 1;
                }
                .sub-title {
                    font-family: PingFangSC-Semibold;
                    font-size: 24px;
                    color: #1E1F24;;
                    line-height: 1;
                    margin: 67px 0 17px;
                }
                .tip {
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    color: #848691;
                    line-height: 1;
                }
            }
        }
        .container {
            width: 1280px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            .left {
                width: 874px;
                background: #fff;
                box-shadow: 0 6px 14px 0 rgba(227,233,237,0.35);
                border-radius: 16px;
                padding: 40px 0 60px 30px;
                box-sizing: border-box;

                .title {
                    font-family: PingFangSC-Semibold;
                    font-size: 20px;
                    color: #1E1F24;
                    line-height: 1;
                }

                .careers {
                    background: @color0;
                    box-sizing: content-box;
                    .honorary {
                        margin-right: 12px;
                    }
                    .intro {
                        line-height: @height4;
                        width: @width1;
                    }
                    .modify-btn {
                        float: right;
                        margin-top: -10px;
                    }
                    ::v-deep{
                        .veui-alert {
                            margin-bottom: 24px;
                        }
                    }
                    .title {
                        color: @color1;
                        font-size: 20px;
                        font-weight: 700;
                    }
                    .show-years {
                        margin-left: 40px;
                    }
                    .show-egister-years {
                        margin-left: 10px;
                    }
                    .careers-text {
                        color: @color2;
                        font-size: 14px;
                        font-weight: normal;
                        padding-left: 12px;
                    }
                    .form {
                        margin-top: 40px;
                        .decs {
                            margin: 10px 0 0 0;
                            width: @width5;
                            font-family: PingFangSC-Regular;
                            font-size: 14px;
                            color: #848691;
                            line-height: 14px;
                            .form-city {
                                color: #05f;
                            }
                        }
                    }
                    .register-philosophy {
                        align-items: center;
                        ::v-deep .veui-field-content {
                            align-items: start;
                        }
                    }
                    .formname {
                        margin-left: 12px;
                    }
                }
                .code-upload {
                    margin-left: 12px;
                }
                .portrait {
                    ::v-deep{
                        .veui-uploader-input-label-image {
                            svg {
                                background: url("../../../assets/img/law/card-portrait.png");
                                background-size: 100% 100%;
                                color: transparent;
                            }
                        }
                    }
                }
                .emblem {
                    ::v-deep{
                        .veui-uploader-input-label-image {
                            svg {
                                background: url("../../../assets/img/law/card-emblem.png");
                                background-size: 100% 100%;
                                color: transparent;
                            }
                        }
                    }
                }
                .decs {
                    color: @color2;
                    height: @height2;
                    margin-left: 12px;
                    position: relative;
                    width: 380px;
                    .pa12 {
                        padding-left: 12px;
                    }
                    .decs-active {
                        font-weight: 600;
                    }
                }
                .licencedecs {
                    width: 420px;
                }
                .diagram {
                    background: url("../../../assets/img/law/law-bg.png");
                    border: 1px solid #e2e6f0;
                    height: 120px;
                    margin-left: 12px;
                    position: relative;
                    width: 120px;
                    img {
                        display: block;
                        height: @height2;
                        width: @width5;
                    }
                    .notify {
                        background: #ebedf5;
                        border-radius: 4px;
                        bottom: 0;
                        height: 28px;
                        left: 0;
                        line-height: 28px;
                        position: absolute;
                        text-align: center;
                        width: 50px;
                    }
                }
                ::v-deep{
                    .textarea {
                        display: block;
                        textarea {
                            display: block;
                            height: 152px;
                            resize: auto;
                            width: @width1;
                        }
                    }
                    .veui-textarea-count {
                        background: transparent;
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #848691;
                        line-height: 14px;
                    }
                    .veui-input {
                        border: 1px solid #E9ECF3;
                        border-radius: 6px;
                        min-height: @height4;
                        line-height: @height4;
                        width: @width1;
                        padding: 0 18px;
                        &:focus {
                            border-color: #0055ff;
                            height: @height4;
                            width: @width1;
                        }
                    }
                    .veui-input.veui-invalid {
                        border-color: #FD503E;
                    }
                    .veui-input.veui-focus {
                        border: 1px solid #0055ff;
                        box-shadow: none;
                    }
                    .user-info.veui-input.veui-focus {
                        border: none;
                    }
                    .user-info.veui-input {
                        border: none;
                    }
                    .veui-number-input {
                        width: @width1;
                        .veui-input-after {
                            display: none;
                        }
                    }
                    .updateImg {
                        width: 150px !important;
                        height: 150px !important;
                        .ivu-upload-drag {
                            width: 150px !important;
                            height: 150px !important;
                            border-radius: 6px;
                        }
                    }
                    .ivu-input-wrapper {
                        width: @width1;
                    }
                    .veui-field-content {
                        flex-wrap: wrap;
                        width: 100%;
                    }
                    .veui-tag {
                        background: #EBEDF5;
                        border-radius: 4px;
                        height: 30px;
                        margin-top: 8px;
                        margin-right: 10px;
                        font-size: 14px;
                        color: #1E1F24;
                    }
                    .veui-select {
                        width: @width1;
                    }
                    .veui-input-after {
                        height: 40px;
                        margin-top: 4px;
                    }
                    .veui-select-trigger, .veui-select-multiple:not(.veui-select-empty) .veui-select-trigger {
                        padding-left: 18px;
                        padding-right: 14px;
                    }
                    .ivu-input {
                        height: @height4;
                        border-radius: 6px;
                        font-size: 16px;
                    }
                    .veui-field-label {
                        height: @height4;
                        justify-content: flex-start;
                        margin-right: 4px !important;
                    }
                    .veui-check-button-group .veui-button {
                        min-width: 94px;
                        height: 40px;
                        border: 1px solid #E9ECF3;
                        border-radius: 6px;
                        box-sizing: border-box;
                        padding: 0 15px;
                        font-size: 16px;
                    }
                    .veui-button .veui-check-button-group-checkmark {
                        display: none;
                    }
                    .veui-check-button-group .veui-button.veui-button-selected {
                        border: 1px solid #05f;
                        color: #05f;
                        box-sizing: border-box;
                        background-color: transparent;
                    }
                    .ivu-cascader-menu .ivu-cascader-menu-item-active {
                        font-family: PingFangSC-Medium;
                        font-size: 14px;
                        color: #0055FF;
                        background: #F5F6F9;
                    }
                    .ivu-icon-ios-arrow-forward:before {
                        display: none;
                    }
                    .ivu-cascader-menu .ivu-cascader-menu-item i {
                        width: 14px;
                        height: 14px;
                        background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/right-trow.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .ivu-cascader .ivu-select-dropdown {
                        margin-top: 10px;
                        background: #FFFFFF;
                        border: 1px solid #EDEEF0;
                        box-shadow: 0 3px 8px 0 rgba(237,238,240,0.71);
                        border-radius: 5px;
                    }
                    .ivu-cascader-menu {
                        border: none;
                    }
                    .ivu-cascader-menu .ivu-cascader-menu-item {
                        width: 160px;
                    }
                    .veui-invalid .ivu-input {
                        border-color: #FD503E;
                    }
                    .veui-invalid .updateImg {
                        .ivu-upload-drag {
                            border: 1px dashed #FD503E;
                            border-radius: 6px;
                        }
                    }
                    .ivu-icon-ios-close-circle:before {
                        content: "一";
                        color: rgba(19, 22, 26, 0);
                        font-size: 16px;
                        font-weight: 600;
                        width: 16px;
                        height: 16px;
                        background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/clear.png') no-repeat;
                        background-size: 16px 16px;
                    }
                    .ivu-cascader-arrow {
                        font-size: 18px;
                        right: 14px;
                        margin-top: -9px;
                    }
                    .ivu-cascader .ivu-cascader-menu-item:hover {
                        background: #F5F6F9;
                    }
                    .veui-select-placeholder {
                        font-size: 16px;
                        color: #B7B9C1;
                    }
                    .veui-label {
                        font-family: PingFangSC-Regular;
                        font-size: 16px;
                        color: #1E1F24;
                    }
                    .veui-field-label::before {
                        font-size: 16px;
                        margin-top: 5px;
                        color: #EB3333;
                    }
                    .veui-input-placeholder {
                        font-family: PingFangSC-Regular;
                        font-size: 16px;
                        color: #B7B9C1;
                    }
                    .veui-message-content {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #EB3333;
                    }
                    .veui-input-clear,.veui-select-clear {
                        .veui-button-native {
                            width: 16px;
                            height: 16px;
                            background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/clear.png') no-repeat;
                            background-size: 16px 16px;
                            svg {
                                display: none;
                            }
                        }
                    }
                    .veui-input-autofill {
                        background: none;
                    }
                    .veui-input-input {
                        font-size: 16px;
                    }
                    .veui-textarea.veui-focus {
                        box-shadow: none;
                    }
                    .textarea-box {
                        position: relative;
                        .text-number {
                            position: absolute;
                            bottom: 11px;
                            right: 22px;
                            font-family: PingFangSC-Regular;
                            font-size: 14px;
                            color: #848691;
                            text-align: right;
                            line-height: 14px;
                        }
                        .text-number-blue {
                            color: #0055FF;
                        }
                        .text-number-red {
                            color: #EB3333;
                        }
                    }
                    .veui-textarea-input {
                        margin: 11px 18px 30px;
                        padding: 0;
                        box-sizing: border-box;
                        width: 532px !important;
                        border-radius: 0;
                        resize: none !important;
                        &::-webkit-input-placeholder {
                            color: #B7B9C1;
                        }
                    }
                    .ivu-input::-webkit-input-placeholder {
                        color: #B7B9C1;
                    }
                    .veui-select-count {
                        display: none;
                    }
                    .veui-field-required-symbol {
                        color: #FD503E;
                    }
                    .veui-input-count {
                        display: none;
                    }
                }
                .s-title {
                    color: @color1;
                    font-size: 14px;
                    font-weight: 700;
                    margin-bottom: 24px;
                    padding-top: 16px;
                }
                .other {
                    ::v-deep{
                        .veui-field-label {
                            width: calc(5em + 6px);
                        }
                    }
                }
                .identity {
                    .veui-field-no-label {
                        margin-left: 0;
                    }
                    .ml12 {
                        margin-left: 12px;
                    }
                }
                .veui-field-no-label {
                    margin-left: 0;
                    margin-top: -8px;
                }
                .submit-field {
                    background: @color0;
                    margin-top: 24px;
                    padding: 24px 24px 0;
                    display: flex;
                    justify-content: center;
                    .ml5 {
                        margin-right: 20px;
                    }
                    .submit-field-btn {
                        width: 200px;
                        height: 44px;
                    }
                    .submit-field-btn-confirm:hover {
                        opacity: 0.92;
                        background: #05f;
                    }
                    ::v-deep{
                        .veui-button[ui~="normal"] {
                            background: #FFFFFF;
                            border: 1px solid #0055FF;
                            border-radius: 4px;
                            box-sizing: border-box;
                            color: #05f;
                        }
                    }
                }
                .veui-field-personal_intro {
                    ::v-deep{
                        .veui-textarea {
                            float: left;
                            width: @width1;
                            border: 1px solid #E9ECF3;
                            border-radius: 6px;
                            font-size: 16px;
                            background: transparent;
                            line-height: 26px;
                        }
                        .veui-field-content {
                            align-items: start;
                            flex-direction: column;
                        }
                    }
                    .personal_intro-assist {
                        margin-top: 10px;
                    }
                }
                .ispass {
                    ::v-deep{
                        .veui-uploader-list-image-mask {
                            display: none;
                            ::v-deep{
                                .veui-uploader {
                                    display: none;
                                }
                            }
                        }
                    }
                }
                .honorary {
                    ::v-deep{
                        .veui-uploader-list-image {
                            max-width: @width1;
                        }
                    }
                }
                .isViewModel {
                    color: #282c33;
                    ::v-deep{
                        .veui-field-label {
                            margin-right: -14px;
                        }
                        .veui-field {
                            margin-bottom: 40px;
                        }
                    }
                }
                .form-href-terms {
                    color: #05f;
                }
            }
            .right {
                width: 386px;
                height: 617px;
                background-image: linear-gradient(180deg, #E1F8FF 0%, #fff 113px);
                box-shadow: 0 6px 14px 0 rgba(227,233,237,0.35);
                border-radius: 16px;
                padding: 40px 30px;
                box-sizing: border-box;
                .title {
                    font-family: PingFangSC-Medium;
                    font-size: 20px;
                    color: #1E1F24;
                    line-height: 1;
                }
                .topic {
                    font-family: PingFangSC-Medium;
                    font-size: 16px;
                    color: #1E1F24;
                    line-height: 1;
                    margin-top: 40px;
                    margin-bottom: 12px;
                }
                .paragraph {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #848691;
                    line-height: 24px;
                }
                .case {
                    display: flex;
                    height: 20px;
                    align-items: center;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #1E1F24;
                    margin-top: 24px;
                    margin-bottom: 12px;
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 6px;
                    }
                }
                .right-img {
                    display: flex;
                    .right-img-item {
                        width: 150px;
                        height: 150px;
                        margin-right: 10px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .error-img {
                    display: flex;
                    justify-content: space-between;
                    .error-img-item {
                        width: 74px;
                        height: 90px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
        .already-user {
            position: fixed;
            left: 0;
            top: 0;
            background: rgba(0,0,0,0.60);
            width: 100vw;
            height: 100vh;
            z-index: 125;

            .already-user-content {
                width: 507px;
                height: 363px;
                background: #fff;
                border-radius: 16px;
                padding-top: 32px;
                box-sizing: border-box;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate3d(-50%, -50%, 0);

                .title {
                    font-family: PingFangSC-Medium;
                    font-size: 20px;
                    color: #1E1F24;
                    letter-spacing: 0;
                    line-height: 24px;
                    text-align: center;
                }

                .sub-title {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #848691;
                    line-height: 14px;
                    text-align: center;
                    margin-top: 12px;
                }

                .close {
                    position: absolute;
                    top: 30px;
                    right: 30px;
                    cursor: pointer;
                }

                .lawyer {
                    width: 443px;
                    height: 100px;
                    background: #F5F6F9;
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 18px;
                    box-sizing: border-box;
                    margin: 30px auto 0;

                    .lawyer-box {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        flex: 1;
                    }

                    .avator {
                        width: 64px;
                        min-width: 64px;
                        height: 64px;
                        border-radius: 50%;
                        overflow: hidden;
                        display: flex;
                        background-image: linear-gradient(to bottom, #BBC1C8, #D9D8E3);
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .lawyer-info {
                        font-family: PingFangSC-Medium;
                        font-size: 18px;
                        color: #1E1F24;
                        text-align: center;
                        line-height: 18px;
                        margin-left: 15px;
                    }
                    .info {
                        width: 68px;
                        height: 22px;
                        background: #05f;
                        border-radius: 11px;
                        text-align: center;
                        line-height: 22px;
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #fff;
                    }
                }
                .btns {
                    width: 363px;
                    height: 52px;
                    background: #0C5BFF;
                    border-radius: 11px;
                    text-align: center;
                    line-height: 52px;
                    font-family: PingFangSC-Medium;
                    font-size: 18px;
                    color: #fff;
                    margin: 35px auto 0;
                    cursor: pointer;
                }
                .sub-bot-title {
                    text-align: center;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #848691;
                    line-height: 1;
                    margin-top: 16px;
                }
            }
        }
        .agree-tip {
            animation-delay: 0.4s;
            animation-duration: .1s;
            animation-iteration-count: 5;
            animation-name: shake-horizontal;
            animation-play-state: running;
            animation-timing-function: ease-in-out;
        }
        @keyframes shake-horizontal {
            0% {
                transform: translate(0,0) rotate(0deg);
            }


            2% {
                transform: translate(-4px,0) rotate(0deg);
            }


            4% {
                transform: translate(2px,0) rotate(0deg);
            }


            6% {
                transform: translate(-3px,0) rotate(0deg);
            }


            8% {
                transform: translate(9px,0) rotate(0deg);
            }


            10% {
                transform: translate(2px,0) rotate(0deg);
            }


            12% {
                transform: translate(-6px,0) rotate(0deg);
            }


            14% {
                transform: translate(-7px,0) rotate(0deg);
            }


            16% {
                transform: translate(2px,0) rotate(0deg);
            }


            18% {
                transform: translate(7px,0) rotate(0deg);
            }


            20% {
                transform: translate(-1px,0) rotate(0deg);
            }


            22% {
                transform: translate(-10px,0) rotate(0deg);
            }


            24% {
                transform: translate(-10px,0) rotate(0deg);
            }


            26% {
                transform: translate(3px,0) rotate(0deg);
            }


            28% {
                transform: translate(-5px,0) rotate(0deg);
            }


            30% {
                transform: translate(4px,0) rotate(0deg);
            }


            32% {
                transform: translate(-6px,0) rotate(0deg);
            }


            34% {
                transform: translate(-2px,0) rotate(0deg);
            }


            36% {
                transform: translate(-6px,0) rotate(0deg);
            }


            38% {
                transform: translate(-2px,0) rotate(0deg);
            }


            40% {
                transform: translate(4px,0) rotate(0deg);
            }


            42% {
                transform: translate(8px,0) rotate(0deg);
            }


            44% {
                transform: translate(-3px,0) rotate(0deg);
            }


            46% {
                transform: translate(-10px,0) rotate(0deg);
            }


            48% {
                transform: translate(4px,0) rotate(0deg);
            }


            50% {
                transform: translate(-6px,0) rotate(0deg);
            }


            52% {
                transform: translate(6px,0) rotate(0deg);
            }


            54% {
                transform: translate(-8px,0) rotate(0deg);
            }


            56% {
                transform: translate(5px,0) rotate(0deg);
            }


            58% {
                transform: translate(9px,0) rotate(0deg);
            }


            60% {
                transform: translate(7px,0) rotate(0deg);
            }


            62% {
                transform: translate(1px,0) rotate(0deg);
            }


            64% {
                transform: translate(2px,0) rotate(0deg);
            }


            66% {
                transform: translate(-2px,0) rotate(0deg);
            }


            68% {
                transform: translate(-7px,0) rotate(0deg);
            }


            70% {
                transform: translate(-1px,0) rotate(0deg);
            }


            72% {
                transform: translate(-6px,0) rotate(0deg);
            }


            74% {
                transform: translate(5px,0) rotate(0deg);
            }


            76% {
                transform: translate(0,0) rotate(0deg);
            }


            78% {
                transform: translate(9px,0) rotate(0deg);
            }


            80% {
                transform: translate(-3px,0) rotate(0deg);
            }


            82% {
                transform: translate(8px,0) rotate(0deg);
            }


            84% {
                transform: translate(-2px,0) rotate(0deg);
            }


            86% {
                transform: translate(-1px,0) rotate(0deg);
            }


            88% {
                transform: translate(-3px,0) rotate(0deg);
            }


            90% {
                transform: translate(4px,0) rotate(0deg);
            }


            92% {
                transform: translate(0,0) rotate(0deg);
            }


            94% {
                transform: translate(4px,0) rotate(0deg);
            }


            96% {
                transform: translate(2px,0) rotate(0deg);
            }


            98% {
                transform: translate(-2px,0) rotate(0deg);
            }
        }
    }

    .veui-overlay-box.register-domain-picker .veui-option-group.veui-option-group-popout .veui-option-group-label {
        width: 160px;
    }
    .veui-overlay-box.register-domain-picker .veui-option-group-box[x-placement*="right"] .veui-option-group-options {
        margin-left: 0;
    }
    .loading-box {
        width: 100vw;
        height: 100vh;
        left: 0;
        top: 0;
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 11;
    }
</style>

<style lang="less">
.lawyer-confirm {
    .veui-overlay-box.register-domain-picker .veui-option-group.veui-option-group-popout .veui-option-group-label {
        width: 160px;
    }
    .veui-overlay-box.register-domain-picker .veui-select-options {
        // box-shadow: none;
        position: relative;
        background: #FFFFFF;
        border: 1px solid #EDEEF0;
        box-shadow: 0 3px 8px 0 rgba(237,238,240,0.71);
        border-radius: 5px;
    }
    .veui-overlay-box.register-domain-picker .veui-option-group {
        width: 160px;
    }
    .veui-overlay-box.show-selected-second .veui-option-group {
        width: 320px;
    }
    .veui-overlay-box.register-domain-picker .veui-option-group-expanded .veui-option-label {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #0055FF;
    }
    .veui-overlay-box.register-domain-picker .veui-option-group-button {
        svg {
            display: none;
        }
        position: relative;
        height: 36px;
    }
    .veui-option-group-expanded .veui-option-group-button {
        background: #F5F6F9;
    }
    .veui-overlay-box.register-domain-picker .veui-option-group-button::after {
        content: "";
        position: absolute;
        top: 12px;
        right: 10px;
        width: 14px;
        height: 14px;
        background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/right-trow.png') no-repeat;
        background-size: 100% 100%;
    }
    .veui-overlay-box.veui-option-group-box[x-placement*="right"] .veui-option-group-options {
        margin-left: -160px;
        width: 160px;
        background: #FFFFFF;
        box-shadow: none;
        .veui-option {
            height: 36px;
        }
        .veui-option-selected {
            background: #F5F6F9;
        }
    }

    .veui-checkbox-box {
        border: none;
        background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/no-selected.png') no-repeat;
        background-size: cover;
        border-radius: 0;
        background-color: none;
        .veui-icon {
            width: 16px;
            height: 16px;
            background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/page/lawyer-info-confirm/select.png') no-repeat;
            background-size: cover;
            transform: translate(-50%, -50%) scale(1);
            background-color: none;
            border-radius: 3px;
        }
    }
    .veui-checkbox :checked + .veui-checkbox-box {
        background-color: transparent;
    }
    .veui-checkbox:hover :checked + .veui-checkbox-box {
        background-color: transparent;
    }
}
</style>
